import { ifElse, replace } from 'f';

export default ifElse(Boolean, replace(/--/g, '\u2014'), () => '');
